// extracted by mini-css-extract-plugin
module.exports = {"titleContent":"SectionTitle_titleContent__O_8V9"};